<template>
    <section class="wrapper-team">
        <p class="team-name">
            {{ teamName }}
        </p>
        <circular-progress-bar
            :color="barColor"
            emptyColor="#eff2f4"
            :progress="percentage || 0"
            :size="100"
            :angle="startAngle"
            :thickness="8"
            :emptyThickness="8"
            class="circular-progress"
        >
            <div class="logo__wrapper">
                <partner-logo
                    class="logo__image"
                    :show-placeholder="!src"
                    :url="src"
                />
            </div>
        </circular-progress-bar>
        <p class="percentage">
            {{ `${percentage}%` }}
        </p>
    </section>
</template>

<script>
// Components
import partnerLogo from '@webapp/components/partner-logo/partner-logo.vue';

import {
    ORANGE_PEEL_COLOR,
    LIME_GREEN_COLOR,
    TORCH_RED_COLOR,
} from '@shared/modules/fan-engagement/store/predictor/predictableSportEvents';

export default {
    name: 'popular-predictions-american-football',
    components: {
        partnerLogo,
    },
    props: {
        percentage: {
            type: Number,
            required: true,
        },
        src: {
            type: [String, Boolean],
            default: '',
        },
        teamName: {
            type: String,
            default: '',
        },
        offset: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            maximum: 0,
        };
    },
    computed: {
        barColor() {
            if (this.percentage === 50) {
                return ORANGE_PEEL_COLOR;
            }

            if (this.percentage > 50) {
                return LIME_GREEN_COLOR;
            }

            return TORCH_RED_COLOR;
        },

        startAngle() {
            const TOP_CENTER = -90;
            const FULL_CIRCLE = 360;

            if (!this.offset) {
                return TOP_CENTER;
            }

            const percentageFilled = this.offset / 100 * FULL_CIRCLE;

            return (TOP_CENTER + percentageFilled);
        },
    },
    watch: {
        percentage: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.maximum = Math.round(newVal);
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper-team {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.circular-progress {
    display: flex;
    align-items: center;
    justify-content: center;
}

.logo {
    &__wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
    }

    &__image {
        border-radius: 50%;
        width: 80px;
        height: 80px;
    }
}

.team-name {
    font-size: 1.5rem;
    font-weight: bold;
    font-family: Nunito;
    text-align: center;
    padding-bottom: 10px;
}

.percentage {
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    font-family: Nunito;
    padding-top: 10px;
}
</style>